import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Alert } from 'quotient-ng-core';

@Component({
    selector: 'q-alert-view',
    templateUrl: './alert-view.component.html',
    styleUrls: ['./alert-view.component.scss']
})
export class AlertViewComponent {
    @Output() onAlertClose = new EventEmitter<Alert>();
    @Input() alert: Alert;
    @Output() newAlertMessage: string;
    ngOnInit(): void {
        let charArry = this.alert.message.split(/\n/g);
        let ul = document.querySelector('#ul');
        charArry.forEach(liTxt => {
            let li = document.createElement('li');
            if (liTxt.length > 0) {
                li.innerHTML = liTxt;
                ul.appendChild(li);
            }
        });
        this.newAlertMessage = this.alert.message.replace(/\n/g, '<br />');
    }
    closeAlert(alert: Alert) {
        this.onAlertClose.emit(alert);
    }
}
